const url = '/facilities';
const Provider = 'Facilities';
const dbModel = 'Facilities';

export { url, Provider, dbModel };
export const TABLE_NAME = 'facilities';
